import classes from './ShareBubble.module.css'
import { ReactComponent as CloseButton } from '../../../../../assests/chat/bina-close-bubble-button.svg';
import { ReactComponent as DownloadSVG } from '../../../../../assests/chat/bina-download-conversation-button.svg';
import { ReactComponent as CopySVG } from '../../../../../assests/chat/bina-copy-to-clipboard-button.svg';
import { useSelector } from 'react-redux';




function ShareBubble(props) {
    const chatState = useSelector(state => state.chat)
    const { texts } = useSelector(state => state.translate);

    const getTranscript = () => {
        let conversation = []
        chatState.transcript.map(m => {
            let sender = "מערכת"
            if (m.sender === "MODEL") {
                sender = "בינה"
            } else if (m.sender === "USER") {
                sender = "משתמש"
            }
            conversation.push(`${sender}: ${m.text}`)
        })
        return conversation.join("\n\n")
    }

    const onDownload = () => {
        const element = document.createElement("a");
        const file = new Blob([getTranscript()], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = `${texts.conversation}.txt`;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        props.onClose()
      }

    const onCopy = () => {
        let conversation = getTranscript()
        navigator.clipboard.writeText(conversation);
        props.onClose()
    }

    return (
        <>
            <div className={classes.Overlay} onClick={props.onClose}></div>
            <div className={classes.BubbleContainer}>
                <div className={classes.BubbleTitleLine}>
                    <div className={classes.BubbleCloseButton} onClick={props.onClose}>
                        <CloseButton />
                    </div>
                    <div className={classes.BubbleTitleContainer}>
                        <div className={classes.BubbleTitle}>
                            {texts.share}
                        </div>
                    </div>
                </div>
                <div className={classes.BubbleOptionsLine}>
                    <button alt={texts.copy} className={classes.BubbleOptionContainer} onClick={onCopy}>
                        <CopySVG/>
                        {texts.copy}
                    </button>
                    <button alt={texts.download} className={classes.BubbleOptionContainer} onClick={onDownload}>
                        <DownloadSVG/>
                        {texts.download}
                    </button>
                </div>
            </div>
        </>
        
    );
}

export default ShareBubble;